// src/shared/course-catalogue.js - the Virtual Store's long courses, as admin names them (v133.58).
// The courses themselves live in games/virtual-store/src/courses.js (COURSES). This list is only their ids,
// titles and module counts, so the admin Courses page can say "5 of 8 modules". A test
// (tests/v133-58-course-passes_test.js) fails if it drifts from COURSES: add a course there, add it here.
export const COURSE_CATALOGUE = [
  { id: 'trainer', title: 'Train the trainer', modules: 8 },
  { id: 'confidence', title: 'Growing your confidence', modules: 8 },   // v133.60 (a draft in the game until Matt approves it)
  { id: 'delegating', title: 'Delegating well', modules: 8 },   // v133.62 (a draft in the game until Matt approves it)
  { id: 'leading', title: 'Leading a team', modules: 8 },   // v133.63 (a draft in the game until Matt approves it)
  { id: 'diverse', title: 'Why diverse teams do better', modules: 8 },   // v133.64 (a draft in the game until Matt approves it)
  { id: 'difficult', title: 'Difficult conversations', modules: 8 },   // v133.65 (a draft in the game until Matt approves it)
  { id: 'feedback', title: 'Giving feedback that helps', modules: 8 },   // v133.66 (a draft in the game until Matt approves it)
  { id: 'levelup', title: 'Level Up: the store manager\'s job', modules: 8 },   // v133.74 (a draft in the game until Matt approves it)
];

export function courseInfo(id) {
  return COURSE_CATALOGUE.find((c) => c.id === id) || { id, title: id, modules: null };
}
